import ServicesTable from './ServicesTable';

export default ServicesTable;
